/**
 * Centralized waffle flag constants
 *
 * These flags control feature rollout across the application.
 */

/**
 * Flag to enable the new public page templates (PublicPage layout).
 * Controls layout only — branding requires enable_branded_pages on top.
 */
export const WAFFLE_FLAG_NEW_PUBLIC_TEMPLATES = "enable_new_public_templates";

/**
 * Flag to enable venue branding (custom themes, colors, fonts).
 * Only takes effect when enable_new_public_templates is also active.
 */
export const WAFFLE_FLAG_BRANDED_PAGES = "enable_branded_pages";
